import React from "react";
import { pemegangKunci } from "@/lib/idem";

// Paket 1: the double-send guard key of one form (see lib/idem.js)
export function useKunciKirim() {
  const ref = React.useRef(null);
  if (!ref.current) ref.current = pemegangKunci();
  return ref.current;
}
